export const FILE_TAGS = {
  DocumentMinotaure: 'document-minotaure',
  DocumentAriane: 'ARIANE_DOCUMENT',
} as const;
